__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-04-21-1776734086-stable-dev/";